import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js';
import LoadMoreObserver from "../../../../components/load-more-observer";
import DropdownMenu from "../../../../components/base/dropdown-menu";
import DOMHelper from "../../../../lib/dom-helper";
import Api from "../../../../lib/api";

import FilterController from "./filter-controller";
import FeedbackFilterService from "./feedback-filter-service";
import MultCoachesBar from "../../../../components/mult-coaches-bar";

export default class FeedbackFilter {
	constructor() {
		this.$root = document.getElementById('reviewsRoot');
		this.$sidebarFilter = document.getElementById('sidebarFilter');
		this.$mobileFiter = document.getElementById('mobileFilter');
		this.$reviewsList = document.getElementById('reviewsList');
		this.$reviewsListContainer = document.getElementById('reviewsListContainer');

		this.sidebarFilterController = null;
		this.mobileFilterController = null;
		this.observer = null;

		this.city = '*';
		this.category = '*';

		this.smoothScroll = new SmoothScroll();

		this.init();
	}

	init() {
		if (Api.currentCityId != 'kz') {
			this.city = Api.currentCityId;
		}
		this.parseHash();

		if (this.city === 'online' && this.category === 'kids') {
			this.category = '*';
		}

		if (window.matchMedia('(max-width: 1024px)').matches) {
			this.initMobile();
		} else {
			this.initSidebar();
		}
	}

	parseHash() {
		let hash = location.hash;

		if (!hash) return;

		hash = hash.replace(/^#/, '');
		const pairs = hash.split('/');

		if (craft.env.cities.includes(pairs[0]) || pairs[0] === '*') {
			this.city = pairs[0];
		}

		if (
			pairs.length > 1 &&
			(craft.env.courseCategories.includes(pairs[1]) || pairs[1] === '*')
		) {
			this.category = pairs[1];
		}
	}

	initMobile() {
		if (this.mobileFilterController != null) return;

		this.mobileFilterController = new FilterController({
			$root: this.$mobileFiter,
			city: this.city,
			category: this.category
		});

		this.mobileFilterController.$root.addEventListener('afterInit', () => {
			let dropdownControllers = [];

			const $dropdownMenuCollection = this.$mobileFiter.querySelectorAll('.dropdown-menu');

			$dropdownMenuCollection.forEach(($dropdown) => {
				const type = $dropdown.classList.contains('-branches') ? 'city' : 'category';

				dropdownControllers.push(new DropdownMenu($dropdown, {
					initialValue: type === 'city' ? this.city : this.category
				}));
			});

			dropdownControllers[0].associated.push(dropdownControllers[1]);
			dropdownControllers[1].associated.push(dropdownControllers[0]);
		});

		this.addControllerListeners(this.mobileFilterController);
	}

	initSidebar() {
		if (this.sidebarFilterController != null) return;

		/* Set checked the radio button with appropriate value */
		const $controls = this.$sidebarFilter.querySelectorAll('[data-review-filter="control"]');
		$controls.forEach(($control) => {
			if ($control.dataset.name === 'city' && $control.dataset.value === this.city) {
				$control.querySelector('input').checked = true;
			} else if ($control.dataset.name === 'category' && $control.dataset.value === this.category) {
				$control.querySelector('input').checked = true;
			}
		});


		this.sidebarFilterController = new FilterController({
			$root: this.$sidebarFilter,
			city: this.city,
			category: this.category
		});
		this.sidebarFilterController.$root.addEventListener('afterInit', () => {
			this.$sidebarFilter.classList.remove('-disabled');
		});
		this.addControllerListeners(this.sidebarFilterController);
	}

	addControllerListeners(controller) {
		controller.$root.addEventListener('afterInit', () => {
			const moreUrl = controller.getUrl();

			if (!this.observer) {
				this.observer = new LoadMoreObserver({
					$root: this.$reviewsList,
					moreUrl,
					afterObserve: () => {
						this.initMultCoachesBars();
						FeedbackFilterService.initVideo(this.$reviewsListContainer);
					}
				});
			}
		});
		controller.$root.addEventListener('valueChange', () => {
			this.observer.moreUrl = controller.getUrl();

			if (!this.observer.observing) {
				this.observer.reinit();
			}

			const rootPos = DOMHelper.getElementTopPosition(this.$root);

			if (window.scrollY > rootPos) {
				this.smoothScroll.animateScroll((rootPos - 75), null, {
					speed: window.scrollY > 10000 ? 50 : ((window.scrollY - rootPos) < 1000 ? 1500 : 250),
					easing: 'easeOutCubic'
				});
			}
		});
	}

	initMultCoachesBars() {
		const $bars = this.$reviewsList.querySelectorAll('.mult-coaches-bar');

		if ($bars.length) {
			$bars.forEach(($bar) => {
				const multCoachesBar = new MultCoachesBar({ $root: $bar });
			});
		}
	}
}